/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Knp_Terms_Add_Term_FailedInputs */

const en_knp_terms_add_term_failed = /** @type {(inputs: Knp_Terms_Add_Term_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to add term: ${i?.error}`)
};

const fr_knp_terms_add_term_failed = /** @type {(inputs: Knp_Terms_Add_Term_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de l’ajout du terme : ${i?.error}`)
};

const de_knp_terms_add_term_failed = /** @type {(inputs: Knp_Terms_Add_Term_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Term konnte nicht hinzugefügt werden: ${i?.error}`)
};

const it_knp_terms_add_term_failed = /** @type {(inputs: Knp_Terms_Add_Term_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile aggiungere il termine: ${i?.error}`)
};

const ru_knp_terms_add_term_failed = /** @type {(inputs: Knp_Terms_Add_Term_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось добавить термин: ${i?.error}`)
};

const es_knp_terms_add_term_failed = /** @type {(inputs: Knp_Terms_Add_Term_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo agregar el término: ${i?.error}`)
};

const zh_cn2_knp_terms_add_term_failed = /** @type {(inputs: Knp_Terms_Add_Term_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`添加术语失败：${i?.error}`)
};

const ja_knp_terms_add_term_failed = /** @type {(inputs: Knp_Terms_Add_Term_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`用語の追加に失敗しました: ${i?.error}`)
};

const hi_knp_terms_add_term_failed = /** @type {(inputs: Knp_Terms_Add_Term_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`टर्म जोड़ने में विफल: ${i?.error}`)
};

const pt_pt2_knp_terms_add_term_failed = /** @type {(inputs: Knp_Terms_Add_Term_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao adicionar o termo: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to add term: {error}" |
*
* @param {Knp_Terms_Add_Term_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_add_term_failed = /** @type {((inputs: Knp_Terms_Add_Term_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Add_Term_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_add_term_failed(inputs)
	if (locale === "de") return de_knp_terms_add_term_failed(inputs)
	if (locale === "it") return it_knp_terms_add_term_failed(inputs)
	if (locale === "ru") return ru_knp_terms_add_term_failed(inputs)
	if (locale === "es") return es_knp_terms_add_term_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_add_term_failed(inputs)
	if (locale === "ja") return ja_knp_terms_add_term_failed(inputs)
	if (locale === "hi") return hi_knp_terms_add_term_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_add_term_failed(inputs)
	return en_knp_terms_add_term_failed(inputs)
});